/**
 * Shubham Creation Header Controller
 * Handles mobile drawer toggles, AJAX cart drawer redirection, scroll-up sticky header, and search modals.
 */
document.addEventListener('DOMContentLoaded', function() {
  
  // 1. MOBILE MENU DRAWER CONTROLLER
  const hamburgerBtn = document.getElementById('shubham-hamburger-btn');
  const navDrawer = document.getElementById('shubham-header-nav');
  const navOverlay = document.getElementById('shubham-menu-overlay');

  function toggleMobileMenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (navDrawer) navDrawer.classList.toggle('active');
    if (navOverlay) navOverlay.classList.toggle('active');

    if (navDrawer && navDrawer.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', toggleMobileMenu);
  }
  if (navOverlay) {
    navOverlay.addEventListener('click', toggleMobileMenu);
  }

  window.shubhamToggleMobileMenu = toggleMobileMenu;

  // 2. STICKY HEADER LISTENER (Scroll Up Only)
  const headerWrapper = document.getElementById('ShubhamCreationHeader');
  let lastScrollTop = 0;

  if (headerWrapper) {
    window.addEventListener('scroll', function() {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Threshold to prevent triggering at the very top of the page
      if (currentScroll > 150) {
        headerWrapper.classList.add('is-sticky');
        
        if (currentScroll > lastScrollTop) {
          // Scrolling down -> hide the header
          headerWrapper.classList.add('is-hidden');
        } else {
          // Scrolling up -> show the header
          headerWrapper.classList.remove('is-hidden');
        }
      } else {
        // Near the top of the page -> reset states
        headerWrapper.classList.remove('is-sticky');
        headerWrapper.classList.remove('is-hidden');
      }
      
      // Update lastScrollTop (ensure it doesn't go below 0 on mobile bounce)
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }, { passive: true });
  }

  // 3. SHOPIFY AJAX CART DRAWER INTERCEPTOR
  const customCartIcon = document.getElementById('shubham-cart-icon');
  if (customCartIcon) {
    customCartIcon.addEventListener('click', function(e) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        e.preventDefault(); 
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active', 'is-active');
        }
      }
    });
  }

  // 4. ESCAPE KEY MODAL DISMISSAL
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (typeof window.shubhamCloseSearch === 'function') window.shubhamCloseSearch();
      if (navDrawer && navDrawer.classList.contains('active')) toggleMobileMenu();
    }
  });

});

// 5. SEARCH MODAL OPEN CONTROLLER
window.shubhamOpenSearch = function(e) {
  if (e) {
    e.preventDefault(); 
    e.stopPropagation();
  }
  const searchModal = document.getElementById('shubham-floating-search');
  const searchInput = document.getElementById('shubham-search-input');
  
  if (searchModal) {
    searchModal.classList.add('active');
    searchModal.setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      if (searchInput) searchInput.focus(); 
    }, 100);
  }
};

// 6. SEARCH MODAL CLOSE CONTROLLER
window.shubhamCloseSearch = function() {
  const searchModal = document.getElementById('shubham-floating-search');
  if (searchModal) {
    searchModal.classList.remove('active');
    searchModal.setAttribute('aria-hidden', 'true');
  }
};